var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramBlanco01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    transform: "translate(116 116)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG+SURBVHgBrVbtccIwDFVy/V82aJigYYKGDRgBJmhGgAmgE9BOAJ0g3YB0gngD6ATuU6xeHSfY5uPdvfNHFD3Jlp0QBaC1LsANeACP+h883oFzuhbivNJxaMDyUoG1vg4NmMUIbPVtaFyhxM0AjZt2DZ7IjxwcWWMFTpIkObkZzEMRebLPtCkOG+teJuwUTWa9O5aWM3v2aHC0K0Rdw0eFfmE9m2L+61wWe5nf6fD6F9KOBvzs2E8qijMnulra3JpT4EIynIIfMqcsW+X44QBGDzJ4IT8UOJF+xmMsA0e9Qb/xvMfFkKesRN3KGMJCbA7CdpnQLilceVkaIUCyeQV1C6OUEq0pQiQIyVY500eKw4lFQukySsnmTcS4v5JzVATeVamkrAKGr3CYw5bFxuBU5vcUhvqrrk92ZD1w96nddDk/3+ATmbIP7SdXodkzOVA2KpkvdRyaM/btPWhfK4NXgpRq5g+4XTbOqrJslfhQtgg/PFB3CZZkljJ4FsAtdYNZQOC9Zwmhmb4PNuSD7l9y9xWwhPj70OjLwD8Zl33nrayaCOdLbW6FQSSRYnyNF2Q29hH8IVM9fAbq3mfWwS8oQQ0hZUGwpQAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramBlanco01);
export default __webpack_public_path__ + "static/media/instagram-blanco-01.03cc8fccd9b1f65b61c1cbfb3add8f38.svg";
export { ForwardRef as ReactComponent };